// /src/pages/parallel/ParallelConfirmationPage.js
import { useNavigate } from "react-router-dom";
import { useParallelPersona } from "../../context/ParallelPersonaContext";
import axios from "axios";
import Header from "../../components/Header";
import "../../styles/ParallelConfirmationPage.css";

const topics = {
  1: "Activities carried out using digital health services",
  2: "Type of digital service used for contacting GP",
  3: "Concerns about communicating with GP via digital services",
  4: "Type of Energy Used at Home",
  5: "Managing Household Energy Using Digital Services",
  6: "Type of uses of digital services for energy",
  7: "Concerns about using digital services for energy",
  8: "Current type of accommodation",
  9: "Experience or interest in looking for social housing",
  10: "Concerns about digital services for social housing",
  11: "Type of use of digital services for housing activities",
};

const ParallelConfirmationPage = () => {
  const {
    dataset,
    location,
    ethnicity,
    topics: selectedTopics,
    setPersonas,
    setPersonaData,
  } = useParallelPersona();
  const navigate = useNavigate();

  const handleGenerate = async () => {
    const requestBody = {
      dataset: "prime",
      dataset_path: "./data/prime.xlsx",
      location,
      ethnicity: [
        "African",
        "Bangladeshi",
        "Caribbean",
        "Chinese",
        "Indian",
        "Pakistani",
      ],
      question_ids: selectedTopics,
    };
    /*const response = await axios.post(
      "https://docker-compose-dev-primepersonacreator-83cd036b.koyeb.app/persona",
      requestBody
    );
    setPersonas(response.data.personas);
    setPersonaData(response.data);*/
    navigate("/parallel/loading", { state: requestBody });
  };

  return (
    <div className="confirmation-page">
      <Header />
      <h2 className="page-title">Confirm Selections</h2>
      <p>
        <strong>Dataset:</strong> {dataset}
      </p>
      <p>
        <strong>Location:</strong>{" "}
        {location === "Both" ? "England and Scotland" : location}
      </p>
      <p>
        <strong>Ethnicity:</strong> {ethnicity.join(", ")}
      </p>
      <p>
        <strong>Topics:</strong>
      </p>
      <ol>
        {selectedTopics.map((key) => (
          <li key={key}>{topics[key]}</li>
        ))}
      </ol>
      <br></br>
      <p>
        You can go ahead and generate personas, or press the back button to make
        any changes.<br></br>
        <br></br>
        Note that the gender and name of the generated personas are randomised
        and not based on the dataset.{" "}
      </p>
      <div className="navigation-buttons">
        <button
          className="back-button"
          onClick={() => navigate("/parallel/topics")}
        >
          Back
        </button>
        <button className="next-button" onClick={handleGenerate}>
          Generate Personas
        </button>
      </div>
    </div>
  );
};

export default ParallelConfirmationPage;
